import { render } from "./ViewMediaMoreBroadcastAndAdvert.vue?vue&type=template&id=0650468b&scoped=true"
import script from "./ViewMediaMoreBroadcastAndAdvert.vue?vue&type=script&lang=js"
export * from "./ViewMediaMoreBroadcastAndAdvert.vue?vue&type=script&lang=js"

import "./ViewMediaMoreBroadcastAndAdvert.vue?vue&type=style&index=0&id=0650468b&lang=postcss&scoped=true"
script.render = render
script.__scopeId = "data-v-0650468b"

export default script